import { useContext } from '@nuxtjs/composition-api';
import { Logger } from '~/helpers/logger';
import DOMPurify from 'isomorphic-dompurify';
import customAttributeMetadata from '~/extensions/magento-api/customAttributeMetadata/customAttributeMetadata.gql';
import { mapValues } from "lodash-es";




export const useCustomAttributeMetadata = () => {
  const context = useContext();

  const getCustomAttributeMetadata = async (params:object) => { 
    const mutationVariables = mapValues(params, (value) => DOMPurify.sanitize(value));
    const { data, errors} = await context.app.$vsf.$magento.api.customMutation({
      mutation: customAttributeMetadata,
      mutationVariables: mutationVariables
    });
    Logger.debug('qrcode [Result]:', { data });
    if (errors) {
      throw new Error(errors[0].message);
    }
    return data;
  };



  return {
    getCustomAttributeMetadata,
  };
};

export default useCustomAttributeMetadata;
